module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('div', [_c('loader')], 1) : _c('div', [_c('h1', [_vm._v("Workflow")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [(_vm.hasLinkedRequests) ? _c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v("\n          Já existem requisições vinculadas a este fluxo. Tomar cuidado com modificações nas "), _c('b', [_vm._v("Zonas de Perigo")]), _vm._v(".\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.workflow.name),
      expression: "workflow.name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.workflow.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.workflow, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Descrição")]), _vm._v(" "), _c('quill-editor', {
    staticClass: "comment_editor",
    attrs: {
      "id": "description",
      "config": _vm.editorConfig
    },
    model: {
      value: (_vm.workflow.description),
      callback: function($$v) {
        _vm.$set(_vm.workflow, "description", $$v)
      },
      expression: "workflow.description"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "panel",
    class: {
      'panel-danger': _vm.hasLinkedRequests
    }
  }, [(_vm.hasLinkedRequests) ? _c('div', {
    staticClass: "panel-heading"
  }, [_c('b', [_vm._v("Zona de Perigo")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "target-group"
    }
  }, [_c('label', {
    attrs: {
      "for": "target"
    }
  }, [_vm._v("Grupo Alvo")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "id": "target",
      "label": "description",
      "track-by": "objectId",
      "options": _vm.groups,
      "showLabels": false,
      "placeholder": "Selecione uma opção"
    },
    model: {
      value: (_vm.workflow.target),
      callback: function($$v) {
        _vm.$set(_vm.workflow, "target", $$v)
      },
      expression: "workflow.target"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "target-group"
    }
  }, [_c('label', {
    attrs: {
      "for": "responsible"
    }
  }, [_vm._v("Grupo Responsável")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "id": "responsible",
      "label": "description",
      "track-by": "objectId",
      "options": _vm.groups,
      "showLabels": false,
      "placeholder": "Selecione uma opção"
    },
    model: {
      value: (_vm.workflow.responsible),
      callback: function($$v) {
        _vm.$set(_vm.workflow, "responsible", $$v)
      },
      expression: "workflow.responsible"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "reqtype-group"
    }
  }, [_c('label', {
    attrs: {
      "for": "reqType"
    }
  }, [_vm._v("Tipo de Requisição")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "id": "reqType",
      "label": "name",
      "track-by": "objectId",
      "options": _vm.reqTypes,
      "showLabels": false,
      "placeholder": "Selecione uma opção"
    },
    model: {
      value: (_vm.workflow.reqType),
      callback: function($$v) {
        _vm.$set(_vm.workflow, "reqType", $$v)
      },
      expression: "workflow.reqType"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "startdate-group"
    }
  }, [_c('label', [_vm._v("Início de Vigência")]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "type": "date",
      "format": "dd/MM/yyyy",
      "language": "pt-br",
      "clear-button": true,
      "input-class": "form-control field-date"
    },
    on: {
      "cleared": _vm.onStartDateCleared
    },
    model: {
      value: (_vm.workflow.startDate),
      callback: function($$v) {
        _vm.$set(_vm.workflow, "startDate", $$v)
      },
      expression: "workflow.startDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "enddate-group"
    }
  }, [_c('label', [_vm._v("Fim de Vigência")]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "type": "date",
      "format": "dd/MM/yyyy",
      "language": "pt-br",
      "clear-button": true,
      "input-class": "form-control field-date"
    },
    on: {
      "cleared": _vm.onEndDateCleared
    },
    model: {
      value: (_vm.workflow.endDate),
      callback: function($$v) {
        _vm.$set(_vm.workflow, "endDate", $$v)
      },
      expression: "workflow.endDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "active"
    }
  }, [_vm._v("Ativo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.workflow.active),
      expression: "workflow.active"
    }],
    attrs: {
      "id": "active",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.workflow.active) ? _vm._i(_vm.workflow.active, null) > -1 : (_vm.workflow.active)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.workflow.active,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.workflow, "active", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.workflow, "active", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.workflow, "active", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "feedback"
    }
  }, [_vm._v("Permitir acompanhamento do usuário")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.workflow.feedback),
      expression: "workflow.feedback"
    }],
    attrs: {
      "id": "feedback",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.workflow.feedback) ? _vm._i(_vm.workflow.feedback, null) > -1 : (_vm.workflow.feedback)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.workflow.feedback,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.workflow, "feedback", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.workflow, "feedback", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.workflow, "feedback", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Define se o usuário alvo do workflow poderá acompanhar o processo passo a passo.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('a', {
    staticClass: "more-options",
    on: {
      "click": function($event) {
        _vm.viewMoreOptions = !_vm.viewMoreOptions
      }
    }
  }, [_vm._v("Outras Opções")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.viewMoreOptions) ? _c('div', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "trammitButton"
    }
  }, [_vm._v("Texto do Botão \"Tramitar\"")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customizations.trammitButton),
      expression: "customizations.trammitButton"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "trammitButton",
      "type": "text",
      "placeholder": "Ex. Tramitar"
    },
    domProps: {
      "value": (_vm.customizations.trammitButton)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customizations, "trammitButton", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "grantButton"
    }
  }, [_vm._v("Texto do Botão \"Deferir\"")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customizations.grantButton),
      expression: "customizations.grantButton"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "grantButton",
      "type": "text",
      "placeholder": "Ex. Deferir"
    },
    domProps: {
      "value": (_vm.customizations.grantButton)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customizations, "grantButton", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "denyButton"
    }
  }, [_vm._v("Texto do Botão \"Indeferir\"")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customizations.denyButton),
      expression: "customizations.denyButton"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "denyButton",
      "type": "text",
      "placeholder": "Ex. Indeferir"
    },
    domProps: {
      "value": (_vm.customizations.denyButton)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customizations, "denyButton", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "canSendInvites"
    }
  }, [_vm._v("Pode enviar Convites?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customizations.canSendInvites),
      expression: "customizations.canSendInvites"
    }],
    attrs: {
      "id": "canSendInvites",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.customizations.canSendInvites) ? _vm._i(_vm.customizations.canSendInvites, null) > -1 : (_vm.customizations.canSendInvites)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.customizations.canSendInvites,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.customizations, "canSendInvites", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.customizations, "canSendInvites", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.customizations, "canSendInvites", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "canEdit"
    }
  }, [_vm._v("Pode editar a inscrição?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customizations.canEdit),
      expression: "customizations.canEdit"
    }],
    attrs: {
      "id": "canEdit",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.customizations.canEdit) ? _vm._i(_vm.customizations.canEdit, null) > -1 : (_vm.customizations.canEdit)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.customizations.canEdit,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.customizations, "canEdit", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.customizations, "canEdit", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.customizations, "canEdit", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "mailContact"
    }
  }, [_vm._v("Email para contato")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customizations.mailContact),
      expression: "customizations.mailContact"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "mailContact",
      "type": "email"
    },
    domProps: {
      "value": (_vm.customizations.mailContact)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customizations, "mailContact", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inviteEmailText"
    }
  }, [_vm._v("Texto do Email de Convites")]), _vm._v(" "), _c('quill-editor', {
    staticClass: "comment_editor",
    attrs: {
      "id": "inviteEmailText",
      "config": _vm.editorConfig
    },
    model: {
      value: (_vm.customizations.inviteEmail),
      callback: function($$v) {
        _vm.$set(_vm.customizations, "inviteEmail", $$v)
      },
      expression: "customizations.inviteEmail"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Você pode usar os parâmetros {NOME_CONVIDADO}, {NOME_WORKFLOW} e {DATA_EXPIRACAO} dentro do texto de E-mail.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "requestEndMessage"
    }
  }, [_vm._v("Texto da requisição submetida")]), _vm._v(" "), _c('quill-editor', {
    staticClass: "comment_editor",
    attrs: {
      "id": "requestEndMessage",
      "config": _vm.editorConfig
    },
    model: {
      value: (_vm.customizations.requestEndMessage),
      callback: function($$v) {
        _vm.$set(_vm.customizations, "requestEndMessage", $$v)
      },
      expression: "customizations.requestEndMessage"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "limit_user_requests"
    }
  }, [_vm._v("Limitar Número de Requisições")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customizations.hasUserRequestsLimit),
      expression: "customizations.hasUserRequestsLimit"
    }],
    attrs: {
      "id": "limit_user_requests",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.customizations.hasUserRequestsLimit) ? _vm._i(_vm.customizations.hasUserRequestsLimit, null) > -1 : (_vm.customizations.hasUserRequestsLimit)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.customizations.hasUserRequestsLimit,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.customizations, "hasUserRequestsLimit", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.customizations, "hasUserRequestsLimit", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.customizations, "hasUserRequestsLimit", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Deve existir um limite de requisições por usuário?")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "limit_user_requests"
    }
  }, [_vm._v("Limite do Número de Requisições")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customizations.userRequestsLimit),
      expression: "customizations.userRequestsLimit"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "limit_user_requests",
      "type": "number"
    },
    domProps: {
      "value": (_vm.customizations.userRequestsLimit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customizations, "userRequestsLimit", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Quantidade de requisições por usuário. (Depende do campo \"Limitar Número de Requisições\")")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "advanced"
    }
  }, [_vm._v("Informações Compartilhadas")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.fields,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "hide-selected": true,
      "placeholder": "Se não especificado, todos campos serão visíveis",
      "label": "name",
      "track-by": "objectId"
    },
    model: {
      value: (_vm.workflow.defaultSharedFields),
      callback: function($$v) {
        _vm.$set(_vm.workflow, "defaultSharedFields", $$v)
      },
      expression: "workflow.defaultSharedFields"
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "tags"
    }
  }, [_vm._v("Tags")]), _vm._v(" "), _c('input-tag', {
    attrs: {
      "tags": _vm.workflow.tags
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Categorias do Workflow na página inicial.")])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "panel",
    class: {
      'panel-danger': _vm.hasLinkedRequests
    }
  }, [(_vm.hasLinkedRequests) ? _c('div', {
    staticClass: "panel-heading"
  }, [_c('b', [_vm._v("Zona de Perigo")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('h3', [_vm._v("Fluxo de processamento")]), _vm._v(" "), _c('steps', {
    attrs: {
      "steps": _vm.steps,
      "editable": true,
      "linked-requests": _vm.hasLinkedRequests,
      "events": {
        addStep: _vm.addStep,
        removeStep: _vm.removeStep,
        addFieldsToTrammit: _vm.addFieldsToTrammit,
        addExtraActions: _vm.addExtraActions
      },
      "groups": _vm.groups
    }
  })], 1)])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "btn-save"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Salvar\n      ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-129ab045"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WorkflowDetail.vue
// module id = 1433
// module chunks = 1